<span
  [matTooltip]="tooltip"
  class="flag-icon flag-icon-{{ code | lowercase }}"
></span>
